import { reactive } from 'vue'
import actions from '@/store/examMetadata/actions'
import state from '@/store/examMetadata/state'
import getters from '@/store/examMetadata/getters'

export const examMetadataModule = {
    state: reactive(state),
    actions,
    getters,
}
